/**
 * MT Show4 Component JavaScript
 * 处理Tab切换和手风琴交互逻辑
 */

(function() {
  'use strict';

  // 初始化函数
  function initMTShow4() {
    const containers = document.querySelectorAll('.mt-show4-container');
    
    containers.forEach(container => {
      initTabs(container);
      initServiceAccordion(container);
      initMobileAccordion(container);
      initMobileServiceAccordion(container);
      initInstallationVideos(container);
      initVideoCarousels(container);
    });
  }

  /**
   * 初始化PC端Tab切换功能
   */
  function initTabs(container) {
    const tabs = container.querySelectorAll('.mt-show4-tab');
    const contents = container.querySelectorAll('.mt-show4-content');

    if (tabs.length === 0 || contents.length === 0) {
      return;
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const blockId = this.getAttribute('data-block-id');
        const targetContent = container.querySelector(`#mt-show4-content-${blockId}`);

        if (!targetContent) {
          return;
        }

        // 移除所有active状态
        tabs.forEach(t => {
          t.classList.remove('mt-show4-tab-active');
          t.setAttribute('aria-selected', 'false');
        });

        contents.forEach(c => {
          c.classList.remove('mt-show4-content-active');
        });

        // 添加active状态到当前tab和content
        this.classList.add('mt-show4-tab-active');
        this.setAttribute('aria-selected', 'true');
        targetContent.classList.add('mt-show4-content-active');

        // 移除自动滚动功能，避免tab栏位置跳动
        // 如果用户需要查看内容，可以自己滚动页面
      });
    });

    // 键盘导航支持
    tabs.forEach(tab => {
      tab.addEventListener('keydown', function(e) {
        const currentIndex = Array.from(tabs).indexOf(this);
        let targetIndex = currentIndex;

        switch(e.key) {
          case 'ArrowRight':
            e.preventDefault();
            targetIndex = (currentIndex + 1) % tabs.length;
            break;
          case 'ArrowLeft':
            e.preventDefault();
            targetIndex = (currentIndex - 1 + tabs.length) % tabs.length;
            break;
          case 'Home':
            e.preventDefault();
            targetIndex = 0;
            break;
          case 'End':
            e.preventDefault();
            targetIndex = tabs.length - 1;
            break;
          case 'Enter':
          case ' ':
            e.preventDefault();
            this.click();
            return;
          default:
            return;
        }

        if (targetIndex !== currentIndex) {
          tabs[targetIndex].focus();
          tabs[targetIndex].click();
        }
      });
    });
  }

  /**
   * 初始化Service & Warranty手风琴功能（PC端）
   */
  function initServiceAccordion(container) {
    const serviceHeaders = container.querySelectorAll('.mt-show4-service-item-header');
    const contents = container.querySelectorAll('.mt-show4-service-item-content');

    contents.forEach((content) => {
      if (content.hasAttribute('hidden')) {
        content.style.height = '0px';
      } else {
        content.style.height = '0px';
        content.setAttribute('hidden', '');
      }

      content.addEventListener('transitionend', (e) => {
        if (e.propertyName !== 'height') return;
        if (content.classList.contains('is-open')) {
          content.style.height = 'auto';
        } else {
          content.hidden = true;
        }
      });
    });

    serviceHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const toggleIndex = this.getAttribute('data-service-toggle');
        const content = container.querySelector(`[data-service-content="${toggleIndex}"]`);
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        if (!content) {
          return;
        }

        // 切换状态
        if (isExpanded) {
          // 收起
          this.setAttribute('aria-expanded', 'false');
          const currentHeight = content.scrollHeight;
          content.style.height = currentHeight + 'px';
          content.offsetHeight;
          content.classList.remove('is-open');
          requestAnimationFrame(() => {
            content.style.height = '0px';
          });
        } else {
          // 展开
          this.setAttribute('aria-expanded', 'true');
          content.hidden = false;
          content.classList.add('is-open');
          content.style.height = '0px';
          const targetHeight = content.scrollHeight;
          requestAnimationFrame(() => {
            content.style.height = targetHeight + 'px';
          });
        }
      });

      // 键盘支持
      header.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });
  }

  /**
   * 初始化移动端手风琴功能
   */
  function initMobileAccordion(container) {
    const mobileHeaders = container.querySelectorAll('.mt-show4-mobile-accordion-header');
    const contents = container.querySelectorAll('.mt-show4-mobile-accordion-content');

    contents.forEach((content) => {
      if (content.hasAttribute('hidden')) {
        content.style.height = '0px';
      } else {
        content.style.height = 'auto';
        content.classList.add('is-open');
      }

      content.addEventListener('transitionend', (e) => {
        if (e.propertyName !== 'height') return;
        if (content.classList.contains('is-open')) {
          content.style.height = 'auto';
        } else {
          content.hidden = true;
        }
      });
    });

    mobileHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const blockId = this.getAttribute('data-mobile-toggle');
        const content = container.querySelector(`[data-mobile-content="${blockId}"]`);
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        if (!content) {
          return;
        }

        // 切换状态（与 mt-womo-faq 同一套 height 动画）
        if (isExpanded) {
          // 收起
          this.setAttribute('aria-expanded', 'false');
          const currentHeight = content.scrollHeight;
          content.style.height = currentHeight + 'px';
          content.offsetHeight;
          content.classList.remove('is-open');
          requestAnimationFrame(() => {
            content.style.height = '0px';
          });
        } else {
          // 展开
          this.setAttribute('aria-expanded', 'true');
          content.hidden = false;
          content.classList.add('is-open');
          content.style.height = '0px';
          const targetHeight = content.scrollHeight;
          requestAnimationFrame(() => {
            content.style.height = targetHeight + 'px';
          });
        }
      });

      // 键盘支持
      header.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });
  }

  /**
   * 初始化移动端Service & Warranty手风琴功能
   */
  function initMobileServiceAccordion(container) {
    const mobileServiceHeaders = container.querySelectorAll('.mt-show4-mobile-service-item-header');
    const contents = container.querySelectorAll('.mt-show4-mobile-service-item-content');

    contents.forEach((content) => {
      if (content.hasAttribute('hidden')) {
        content.style.height = '0px';
      } else {
        content.style.height = '0px';
        content.setAttribute('hidden', '');
      }

      content.addEventListener('transitionend', (e) => {
        if (e.propertyName !== 'height') return;
        if (content.classList.contains('is-open')) {
          content.style.height = 'auto';
        } else {
          content.hidden = true;
        }
      });
    });

    mobileServiceHeaders.forEach(header => {
      header.addEventListener('click', function() {
        const toggleIndex = this.getAttribute('data-mobile-service-toggle');
        const content = container.querySelector(`[data-mobile-service-content="${toggleIndex}"]`);
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        if (!content) {
          return;
        }

        // 切换状态
        if (isExpanded) {
          // 收起
          this.setAttribute('aria-expanded', 'false');
          const currentHeight = content.scrollHeight;
          content.style.height = currentHeight + 'px';
          content.offsetHeight;
          content.classList.remove('is-open');
          requestAnimationFrame(() => {
            content.style.height = '0px';
          });
        } else {
          // 展开
          this.setAttribute('aria-expanded', 'true');
          content.hidden = false;
          content.classList.add('is-open');
          content.style.height = '0px';
          const targetHeight = content.scrollHeight;
          requestAnimationFrame(() => {
            content.style.height = targetHeight + 'px';
          });
        }
      });

      // 键盘支持
      header.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });
  }

  /**
   * 初始化安装视频的封面点击播放逻辑（PC + 移动端）
   */
  function initInstallationVideos(container) {
    const covers = container.querySelectorAll('[data-mt-video-cover]');

    if (!covers.length) return;

    covers.forEach(cover => {
      cover.addEventListener('click', function() {
        const wrapper = this.closest('.mt-show4-installation-video, .mt-show4-mobile-installation-video');
        if (!wrapper) return;

        const iframe = wrapper.querySelector('iframe');

        if (iframe) {
          let src = iframe.getAttribute('src') || '';

          if (src && !src.includes('autoplay=1')) {
            const separator = src.includes('?') ? '&' : '?';
            iframe.setAttribute('src', src + separator + 'autoplay=1');
          }
        }

        this.classList.add('mt-show4-cover-hidden');
        wrapper.classList.add('mt-video-playing');
      });
    });
  }

  /**
   * 初始化视频轮播图功能
   */
  function initVideoCarousels(container) {
    // Desktop video carousels
    const desktopCarousels = container.querySelectorAll('[data-video-carousel]');
    desktopCarousels.forEach(carousel => {
      initSingleVideoCarousel(carousel, false);
    });

    // Mobile video carousels
    const mobileCarousels = container.querySelectorAll('[data-video-carousel-mobile]');
    mobileCarousels.forEach(carousel => {
      initSingleVideoCarousel(carousel, true);
    });
  }

  /**
   * 初始化单个视频轮播图
   */
  function initSingleVideoCarousel(carousel, isMobile) {
    const track = carousel.querySelector(isMobile ? '.mt-show4-mobile-video-carousel-track' : '.mt-show4-video-carousel-track');
    const slides = carousel.querySelectorAll(isMobile ? '.mt-show4-mobile-video-carousel-slide' : '.mt-show4-video-carousel-slide');
    const prevBtn = carousel.querySelector(isMobile ? '.mt-show4-mobile-video-carousel-prev' : '.mt-show4-video-carousel-prev');
    const nextBtn = carousel.querySelector(isMobile ? '.mt-show4-mobile-video-carousel-next' : '.mt-show4-video-carousel-next');
    const dots = carousel.querySelectorAll(isMobile ? '.mt-show4-mobile-video-carousel-dot' : '.mt-show4-video-carousel-dot');

    if (!track || slides.length === 0) {
      return;
    }

    let currentIndex = 0;

    function updateCarousel() {
      const offset = -currentIndex * 100;
      track.style.transform = `translateX(${offset}%)`;

      // Update dots
      dots.forEach((dot, index) => {
        if (index === currentIndex) {
          dot.classList.add('is-active');
        } else {
          dot.classList.remove('is-active');
        }
      });

      // Update button states
      if (prevBtn) {
        prevBtn.disabled = currentIndex === 0;
        prevBtn.style.opacity = currentIndex === 0 ? '0.5' : '1';
      }
      if (nextBtn) {
        nextBtn.disabled = currentIndex === slides.length - 1;
        nextBtn.style.opacity = currentIndex === slides.length - 1 ? '0.5' : '1';
      }
    }

    function goToSlide(index) {
      if (index < 0 || index >= slides.length) {
        return;
      }
      currentIndex = index;
      updateCarousel();
    }

    function goToPrev() {
      goToSlide(currentIndex - 1);
    }

    function goToNext() {
      goToSlide(currentIndex + 1);
    }

    // Event listeners
    if (prevBtn) {
      prevBtn.addEventListener('click', goToPrev);
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', goToNext);
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goToSlide(index);
      });
    });

    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    track.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swipe left - go to next
          goToNext();
        } else {
          // Swipe right - go to previous
          goToPrev();
        }
      }
    }

    // Initialize
    updateCarousel();
  }

  /**
   * 处理窗口大小变化，确保正确的显示/隐藏
   */
  function handleResize() {
    const containers = document.querySelectorAll('.mt-show4-container');
    
    containers.forEach(container => {
      const isMobile = window.innerWidth <= 768;
      
      // 移动端Service & Warranty手风琴功能已通过initMobileServiceAccordion处理
      if (isMobile) {
        // 可以在这里添加其他移动端特定的处理逻辑
      }
    });
  }

  /**
   * 处理动态内容加载（如果使用AJAX加载产品数据）
   */
  function handleDynamicContent() {
    // 监听DOM变化，重新初始化
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && node.classList && node.classList.contains('mt-show4-container')) {
              initMTShow4();
            } else if (node.nodeType === 1 && node.querySelector && node.querySelector('.mt-show4-container')) {
              initMTShow4();
            }
          });
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // DOM加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initMTShow4();
      handleDynamicContent();
    });
  } else {
    initMTShow4();
    handleDynamicContent();
  }

  // 窗口大小变化时重新检查
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      handleResize();
    }, 250);
  });

  // 导出到全局作用域（如果需要）
  window.MTShow4 = {
    init: initMTShow4,
    reinit: function() {
      initMTShow4();
    }
  };

})();

